var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWackerWall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576.74 544.922",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ground_Floor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: ".004 15.136 26.219 0 576.739 317.871 550.523 333.008 .004 15.136",
    fill: "#fae6b4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 15.136 0 227.05 550.523 544.922 550.523 333.008 0 15.136",
    fill: "#fff2d4"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "576.739 529.775 550.515 544.915 550.516 333.011 576.74 317.872 576.739 529.775",
    fill: "#e2cd9f"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.733,73.461c8.541,3.985,17.317,8.77,25.962,14.156,4.992,3.11,10.343,6.614,14.802,7.905,2.645-6.393,2.199-14.723,1.744-22.991-12.796-8.587-25.791-16.732-38.815-24.33-10.126-5.907-4.994,3.388-4.953,6.994,.017,1.509,1.417,18.338,1.261,18.265Z",
    fill: "none",
    stroke: "#ff00ed",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.712,113.447c4.846,5.853,9.491,11.69,13.921,17.494,2.263,2.965,4.485,5.943,6.065,8.747,2.82,5.003,3.455,9.311,1.766,11.99-9.049-4.925-18.094-9.848-27.135-14.769-3.153-1.716-13.812-7.096-15.978-10.027-1.893-2.562,4.577-3.257,6.096-3.924,5.819-2.556,10.923-5.736,15.265-9.511Z",
    fill: "none",
    stroke: "#65fc03",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.289,161.217c-.229,5.113-.459,10.226-.688,15.338",
    fill: "none",
    stroke: "#06edf9",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.025,174.615c-.584,5.209-.708,10.691-.373,16.423",
    fill: "none",
    stroke: "#06edf9",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.066,171.662c5.531,4.021,9.778,8.808,14.646,13.264,5.618,5.143,12.464,10.097,19.023,13.155s12.652,3.916,14.5,1.423",
    fill: "none",
    stroke: "#06edf9",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.138,225.121c-6.644-3.114-14.335-9.417-19.775-10.293-1.907-.307-3.143,.164-4.144,.778-3.017,1.853-4.368,5.071-3.885,9.257,.145,1.256,.462,2.624,1.379,4.204,1.502,2.589,4.452,5.478,7.495,8.147,9.782,8.581,23.053,16.767,31.744,17.723,4.88,.537,7.668-1.281,8.611-4.194s.194-6.855-1.009-10.953c-.714-2.434-1.631-5.02-3.787-7.929s-5.817-6.229-9.543-8.065c-6.589-3.248-9.325-.38-14.559-1.079",
    fill: "none",
    stroke: "#ff7f00",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.772,234.125c8.622,4.039,17.481,8.882,26.207,14.327,5.038,3.144,10.439,6.686,14.941,8.003,2.679-6.403,2.238-14.765,1.788-23.064-12.915-8.677-26.031-16.912-39.178-24.598-10.221-5.976-5.049,3.377-5.011,6.996,.016,1.514,1.41,18.41,1.253,18.336Z",
    fill: "none",
    stroke: "#fc0000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.883,274.8c4.888,5.897,9.573,11.775,14.041,17.621,2.282,2.986,4.523,5.985,6.116,8.806,2.843,5.034,3.479,9.36,1.769,12.041-9.135-4.985-18.265-9.968-27.391-14.949-3.182-1.737-13.943-7.186-16.127-10.137-1.91-2.58,4.627-3.247,6.162-3.91,5.88-2.538,11.04-5.705,15.43-9.473Z",
    fill: "none",
    stroke: "#ff00ed",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.893,99.157c-.221,5.089-.442,10.177-.662,15.265",
    fill: "none",
    stroke: "#ff7f00",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.387,112.447c-.571,5.185-.688,10.64-.349,16.344",
    fill: "none",
    stroke: "#ff7f00",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.837,109.577c5.476,3.991,9.682,8.747,14.503,13.173,5.563,5.107,12.34,10.026,18.832,13.057s12.519,3.874,14.344,1.39",
    fill: "none",
    stroke: "#ff7f00",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.041,165.861c-6.576-3.087-14.19-9.346-19.573-10.209-1.887-.302-3.109,.168-4.098,.782-2.983,1.849-4.314,5.053-3.832,9.218,.145,1.249,.46,2.61,1.369,4.181,1.489,2.574,4.41,5.444,7.424,8.095,9.687,8.522,22.823,16.646,31.421,17.583,4.828,.526,7.583-1.288,8.513-4.188s.183-6.822-1.011-10.898c-.709-2.42-1.619-4.993-3.755-7.884s-5.761-6.188-9.449-8.01c-6.521-3.221-9.225-.362-14.403-1.049",
    fill: "none",
    stroke: "#06edf9",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.641,280.077c2.166,.045,4.938,.604,7.982,2.345,3.411,1.951,6.411,4.982,8.153,7.575,3.782,5.63,2.525,9.543-1.338,10.837s-9.921,.421-16.001-.688c-1.827-.333-3.75-.715-5.949-1.771-4.763-2.288-8.949-6.758-11.818-10.501-6.24-8.143-10.192-15.918-11.325-22.281-.107-.603-.144-1.244,.551-1.243,.37,0,.887,.189,1.39,.387,4.872,1.907,10.276,5.125,15.006,8.829,1.614,1.264,5.109,5.044,6.503,5.858,2.712,1.583,4.909,.612,6.846,.652Z",
    fill: "none",
    stroke: "#65fc03",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.102,323.983c.609-.296,1.884-.315,2.979,.701,7.017,10.665,14.2,21.808,14.442,29.677-13.41-12.267-31.389-23.064-42.214-35.562,16.57,9.425,32.121,11.858,48.545,22.451,.381,1.689-1.825,1.697-3.845,1.549-4.274-.313-24.782,.847-30.4-4.87-5.742-5.842,7.691-12.585,10.493-13.947Z",
    fill: "none",
    stroke: "#06edf9",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.417,322.215c16.79,15.869,28.479,32.336,45.59,48.154",
    fill: "none",
    stroke: "#ff00ed",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.133,344.983c9.361-3.882,21.564-5.293,35.936-4.152",
    fill: "none",
    stroke: "#ff00ed",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.905,382.87c-.351,7.455-.702,14.909-1.052,22.363",
    fill: "none",
    stroke: "#ff00ed",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.427,381.351c13.441,7.777,26.891,15.559,40.35,23.346",
    fill: "none",
    stroke: "#ff00ed",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.209,339.407c8.659,4.071,17.556,8.947,26.319,14.426,5.06,3.164,10.483,6.727,15.006,8.059,2.695-6.403,2.256-14.778,1.809-23.089-12.97-8.728-26.141-17.013-39.344-24.75-10.264-6.015-5.074,3.366-5.038,6.99,.015,1.516,1.406,18.438,1.248,18.364Z",
    fill: "none",
    stroke: "#fc0000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.84,380.495c4.908,5.919,9.61,11.82,14.096,17.688,2.291,2.997,4.54,6.007,6.139,8.836,2.853,5.049,3.49,9.383,1.771,12.063-9.174-5.02-18.343-10.037-27.509-15.052-3.196-1.749-14.003-7.238-16.196-10.2-1.917-2.589,4.65-3.237,6.192-3.896,5.909-2.523,11.094-5.679,15.506-9.439Z",
    fill: "none",
    stroke: "#65fc03",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.581,429.156l-.725,15.408",
    fill: "none",
    stroke: "#06edf9",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.644,442.804c-.601,5.23-.737,10.738-.407,16.501",
    fill: "none",
    stroke: "#06edf9",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.129,439.542c5.606,4.083,9.907,8.927,14.839,13.443,5.692,5.211,12.63,10.243,19.281,13.367s12.832,4.033,14.711,1.542",
    fill: "none",
    stroke: "#06edf9",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.758,166.98c-6.544-3.08-14.124-9.323-19.48-10.184-1.877-.302-3.094,.168-4.077,.78-2.966,1.845-4.29,5.041-3.808,9.195,.145,1.246,.46,2.604,1.364,4.17,1.483,2.567,4.391,5.43,7.391,8.075,9.642,8.501,22.717,16.605,31.272,17.539,4.804,.525,7.544-1.285,8.467-4.177,.923-2.893,.179-6.805-1.011-10.87-.707-2.414-1.614-4.98-3.74-7.864s-5.735-6.173-9.405-7.99c-6.49-3.213-9.178-.361-14.331-1.047",
    fill: "none",
    stroke: "#ff7f00",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.767,502.332c8.742,4.126,17.724,9.062,26.568,14.602,5.107,3.199,10.582,6.8,15.148,8.158,2.73-6.413,2.297-14.82,1.854-23.163-13.091-8.82-26.386-17.197-39.713-25.023-10.361-6.084-5.129,3.354-5.097,6.991,.013,1.522,1.399,18.511,1.239,18.435Z",
    fill: "none",
    stroke: "#65fc03",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.607,216.293c4.821,5.845,9.441,11.672,13.849,17.467,2.251,2.96,4.462,5.933,6.034,8.731,2.807,4.991,3.44,9.285,1.762,11.949-8.999-4.933-17.993-9.864-26.983-14.792-3.135-1.719-13.734-7.109-15.89-10.035-1.884-2.557,4.548-3.231,6.058-3.891,5.783-2.529,10.856-5.682,15.17-9.429Z",
    fill: "none",
    stroke: "#ff00ed",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.416,365.276c-.233,5.112-.466,10.223-.698,15.334",
    fill: "none",
    stroke: "#ff7f00",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.232,378.813c-.588,5.205-.716,10.686-.383,16.421",
    fill: "none",
    stroke: "#ff7f00",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.135,375.637c5.549,4.053,9.809,8.865,14.693,13.35,5.636,5.176,12.504,10.17,19.086,13.267,6.584,3.098,12.696,3.99,14.552,1.508",
    fill: "none",
    stroke: "#ff7f00",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.038,433.145c-6.667-3.154-14.383-9.502-19.844-10.411-1.914-.319-3.155,.145-4.16,.754-3.03,1.835-4.387,5.045-3.904,9.234,.145,1.257,.463,2.626,1.382,4.212,1.507,2.598,4.466,5.505,7.519,8.192,9.814,8.639,23.13,16.905,31.853,17.913,4.898,.566,7.697-1.235,8.645-4.142s.198-6.854-1.007-10.959c-.715-2.438-1.635-5.03-3.797-7.952s-5.835-6.263-9.574-8.122c-6.612-3.287-9.36-.436-14.613-1.166",
    fill: "none",
    stroke: "#06edf9",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.842,221.37c2.132,.041,4.86,.592,7.859,2.315,3.361,1.931,6.318,4.934,8.036,7.505,3.731,5.582,2.501,9.467-1.298,10.759s-9.762,.435-15.749-.656c-1.798-.328-3.692-.703-5.857-1.748-4.691-2.263-8.819-6.693-11.648-10.404-6.155-8.072-10.058-15.783-11.184-22.097-.107-.599-.144-1.235,.54-1.234,.364,0,.873,.187,1.369,.381,4.798,1.885,10.122,5.07,14.783,8.738,1.59,1.252,5.036,4.998,6.41,5.804,2.672,1.566,4.832,.599,6.738,.636Z",
    fill: "none",
    stroke: "#65fc03",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.561,264.968c.599-.295,1.853-.316,2.933,.691,6.924,10.574,14.012,21.622,14.263,29.432-13.218-12.153-30.931-22.84-41.606-35.227,16.324,9.327,31.633,11.716,47.814,22.203,.378,1.676-1.793,1.688-3.781,1.544-4.206-.303-24.388,.882-29.926-4.782-5.661-5.789,7.548-12.504,10.302-13.861Z",
    fill: "none",
    stroke: "#06edf9",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.598,263.079c16.55,15.723,28.082,32.048,44.947,47.719",
    fill: "none",
    stroke: "#ff00ed",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.294,285.671c9.205-3.869,21.212-5.29,35.357-4.182",
    fill: "none",
    stroke: "#ff00ed",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.912,323.253c-.333,7.4-.665,14.8-.998,22.198",
    fill: "none",
    stroke: "#ff00ed",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.788,321.783c13.241,7.696,26.49,15.397,39.749,23.104",
    fill: "none",
    stroke: "#ff00ed",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWackerWall);
export default __webpack_public_path__ + "static/media/wacker-wall.fae212aa6d4c4e576dc9a795d91b289b.svg";
export { ForwardRef as ReactComponent };